import DOMPurify from 'dompurify';

// Sanitizes email HTML for rendering. Default (strict) profile is for regular app DOM — it forbids
// <style> so a pasted email's CSS can't restyle the app. Pass { keepStyles: true } only when the
// result renders inside a sandboxed iframe: it preserves <style> blocks and presentational
// attributes so designed HTML email documents keep their layout.
export const sanitizeEmailHtml = (html, { keepStyles = false } = {}) => DOMPurify.sanitize(html || '', keepStyles ? DOCUMENT_PROFILE : STRICT_PROFILE);

const EMAIL_URI_REGEXP = /^(?:(?:https?|mailto|cid):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;

const STRICT_PROFILE = {
  ALLOWED_URI_REGEXP: EMAIL_URI_REGEXP,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'meta'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick']
};

const DOCUMENT_PROFILE = {
  ADD_TAGS: ['style'],
  ADD_ATTR: ['bgcolor', 'background', 'align', 'valign', 'border', 'cellpadding', 'cellspacing', 'width', 'height', 'contenteditable'],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'link', 'meta'],
  ALLOWED_URI_REGEXP: EMAIL_URI_REGEXP
};
